var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldNoteFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.56c.25-.03.48-.06.75-.06h.75V2zM15.75 2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5H15c.27 0 .5.03.75.06V2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14c-1.05 0-2.04.37-2.81.99-1.04.82-1.69 2.1-1.69 3.51 0 .84.24 1.65.65 2.31.32.52.73.98 1.22 1.33.74.54 1.64.86 2.63.86 1.14 0 2.17-.42 2.96-1.12.35-.29.65-.65.89-1.06a4.49 4.49 0 0 0-1.06-5.85c-.77-.61-1.74-.97-2.79-.97zm-2.14 4.5c1.18 0 2.14-.96 2.14-2.14 0 1.18.96 2.14 2.14 2.14-1.18 0-2.14.96-2.14 2.14 0-1.18-.96-2.14-2.14-2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5c0 .41-.34.75-.75.75s-.75-.34-.75-.75V3.5h-6.5V5c0 .41-.34.75-.75.75s-.75-.34-.75-.75V3.56C3.3 3.83 2 5.73 2 8.5V17c0 3 1.5 5 5 5h4.13c.76 0 1.27-.85 1.08-1.59-.14-.54-.21-1.1-.21-1.66 0-2.08.93-4 2.54-5.27A6.706 6.706 0 0 1 18.75 12h.04c.63 0 1.21-.46 1.21-1.09V8.5c0-2.77-1.3-4.67-4.25-4.94V5zM7 16.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H7zm0-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldNoteFavorite);
export default __webpack_public_path__ + "static/media/vuesax-bold-note-favorite.83ea6f4a2e98f84e70f8e82ea4942bff.svg";
export { ForwardRef as ReactComponent };